import config from '../config';
import { v4 } from 'uuid';

type AnalyticsCookie = {
  loggedInGuid: string;
  loggedOutGuid: string;
};

export function getAnalyticsCookie(): AnalyticsCookie {
  const [, ...values] =
    document.cookie
      .split('; ')
      .find(x => x.startsWith(`${config.analyticsCookieName}=`))
      ?.split('=') ?? [];

  const analyticsCookieValue = new URLSearchParams(values.join('='));

  return {
    loggedInGuid: analyticsCookieValue.get('logged_in_guid') ?? '',
    loggedOutGuid: analyticsCookieValue.get('logged_out_guid') ?? '',
  };
}

export function createAnalyticsCookie(loggedInGuid?: string) {
  const cookieValue = new URLSearchParams();
  cookieValue.set('logged_in_guid', '00000000-0000-0000-0000-000000000000');
  cookieValue.set('logged_out_guid', v4());
  cookieValue.set('source', 'JG.Pages.Creation');

  if (loggedInGuid) {
    cookieValue.set('logged_in_guid', loggedInGuid);
  }

  const domain = 'domain=.justgiving.com;';
  const path = `path=/;`;
  const maxAge = `max-age=${60 * 60 * 24 * 365 * 10};`; // 10 Years

  document.cookie = `${
    config.analyticsCookieName
  }=${cookieValue.toString()};${domain}${path}${maxAge}`;
}

export function analyticsCookieExists() {
  return document.cookie.includes(`${config.analyticsCookieName}=`);
}
